<template>
  <div v-if="!isMobile">
    <nav>
      <v-app-bar app style="z-index:999;" height="80">
        <v-toolbar-title>
          <v-breadcrumbs :items="items" large></v-breadcrumbs>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="pa-1 mr-1">
          <v-select
            height="42"
            :items="location"
            item-value="_id"
            label="Location Name"
            v-model="locationItem"
            @change="updateLocation"
            :item-text="
              (location) => {
                return location.result[0].location;
              }
            "
            prepend-inner-icon="mdi-map-marker"
            solo
            outlined
            dense
            style="font-size: 15px;"
            hide-details
          ></v-select>
        </div>
        <v-md-date-range-picker :presets="presets" opens="right" @change="updateData">
          <v-card class="pa-2" slot="input" style="outline:1px solid grey;">
            <v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate($store.state.dateTime1) }} - {{ formatDate($store.state.dateTime2) }}</span>
          </v-card>
        </v-md-date-range-picker>
      </v-app-bar>
    </nav>

    <v-card class="pick mt-2" flat>
      <v-row>
        <v-col>
          <div style="padding-top: 10px; color: grey;" justify="center" align="center">
            Last Updated: <span v-if="datetime.length == 0">No data</span
            ><span v-else>
              <span v-if="lastUpdate(datetime[0]).includes('ago') == true">{{ lastUpdate(datetime[0]) }}</span>
              <span v-else>{{ lastUpdate(datetime[0]).substring(2) }} ago</span></span
            >
          </div>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-card class="pa-3 mb-2" color="grey;" style="background:#eee;">
          <span> <v-icon color="green">mdi-circle</v-icon> = Water Used <v-icon color="white">mdi-circle</v-icon> = Water Not Use <v-icon color="red">mdi-circle</v-icon> = Water Exceeds 10000L </span>
        </v-card>
      </v-row>
    </v-card>
    <v-container>
      <v-row v-if="location1[0] != ''">
        <v-col>
          <v-row dense>
            <v-col>
              <v-card class="mx-auto text-center" color="grey" dark max-width="200" max-height="100" @click="waterFlow1">
                <v-card-text>
                  <span style="font-size:11px;color:black;" v-if="waterFlow.length == 0">No Data</span>
                  <span style="font-size:11px;color:black;" v-else>{{ console1[0] }}</span>
                  <div style="font-size:15px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>
                    {{ location1[0] }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="mx-auto text-center" color="green" dark max-width="200" max-height="100" v-if="value1[0] != 0 && waterFlow.length != 0">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recent Flow rate
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>
                    <div v-if="value1[0] == null">{{ value1[0] }}<span style="font-size:15px;color:black;">L/min</span></div>
                    <div v-else>{{ value1[0].toFixed(2) }}<span style="font-size:15px;color:black;">L/min</span></div>
                  </div>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" v-else>
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recent Flow Rate
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>
                    <div v-if="value1[0] == null">{{ value1[0] }}<span style="font-size:15px;color:black;">L/min</span></div>
                    <div v-else>{{ value1[0].toFixed(2) }}<span style="font-size:15px;color:black;">L/min</span></div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col>
              <v-card class="mx-auto text-center" color="red" dark max-width="200" max-height="100" v-if="value1.reduce((a, b) => a + b, 0) >= 10000 && waterFlow.length != 0">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Total Volume
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>{{ value1.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" v-else>
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Total Volume
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>{{ value1.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="location2[0] != ''">
        <v-col>
          <v-row dense>
            <v-col>
              <v-card class="mx-auto text-center" color="grey" dark max-width="200" max-height="100" @click="waterFlow2">
                <v-card-text>
                  <span style="font-size:11px;color:black;" v-if="waterFlow.length == 0">No Data</span>
                  <span style="font-size:11px;color:black;" v-else>{{ console2[0] }}</span>
                  <div style="font-size:15px;color:black" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>
                    {{ location2[0] }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="mx-auto text-center" color="green" dark max-width="200" max-height="100" v-if="value2[0] != 0 && waterFlow.length != 0">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recent Flow rate
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>
                    <div v-if="value2[0] == null">{{ value2[0] }}<span style="font-size:15px;color:black;">L/min</span></div>
                    <div v-else>{{ value2[0].toFixed(2) }}<span style="font-size:15px;color:black;">L/min</span></div>
                  </div>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" v-else>
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recent Flow rate
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>
                    <div v-if="value2[0] == null">{{ value2[0] }}<span style="font-size:15px;color:black;">L/min</span></div>
                    <div v-else>{{ value2[0].toFixed(2) }}<span style="font-size:15px;color:black;">L/min</span></div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="mx-auto text-center" color="red" dark max-width="200" max-height="100" v-if="value2.reduce((a, b) => a + b, 0) >= 10000 && waterFlow.length != 0">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Total Volume
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>{{ value2.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" v-else>
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Total Volume
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>{{ value2.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="location3[0] != ''">
        <v-col>
          <v-row dense>
            <v-col>
              <v-card class="mx-auto text-center" color="grey" dark max-width="200" max-height="100" @click="waterFlow3">
                <v-card-text>
                  <span style="font-size:11px;color:black;" v-if="waterFlow.length == 0">No Data</span>
                  <span style="font-size:11px;color:black;" v-else>{{ console3[0] }}</span>
                  <div style="font-size:15px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>
                    {{ location3[0] }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="mx-auto text-center" color="green" dark max-width="200" max-height="100" v-if="value3[0] != 0 && waterFlow.length != 0">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recent Flow rate
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>
                    <div v-if="value3[0] == null">{{ value3[0] }}<span style="font-size:15px;color:black;">L/min</span></div>
                    <div v-else>{{ value3[0].toFixed(2) }}<span style="font-size:15px;color:black;">L/min</span></div>
                  </div>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" v-else>
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recent Flow Rate
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>
                    <div v-if="value3[0] == null">{{ value3[0] }}<span style="font-size:15px;color:black;">L/min</span></div>
                    <div v-else>{{ value3[0].toFixed(2) }}<span style="font-size:15px;color:black;">L/min</span></div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="mx-auto text-center" color="red" dark max-width="200" max-height="100" v-if="value3.reduce((a, b) => a + b, 0) >= 10000 && waterFlow.length != 0">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Total Volume
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>{{ value3.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" v-else>
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Total Volume
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>{{ value3.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="location4[0] != ''">
        <v-col>
          <v-row dense>
            <v-col>
              <v-card class="mx-auto text-center" color="grey" dark max-width="200" max-height="100" @click="waterFlow4">
                <v-card-text>
                  <span style="font-size:11px;color:black;" v-if="waterFlow.length == 0">No Data</span>
                  <span style="font-size:11px;color:black;" v-else>{{ console4[0] }}</span>
                  <div style="font-size:15px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>
                    {{ location4[0] }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="mx-auto text-center" color="green" dark max-width="200" max-height="100" v-if="value4[0] != 0 && waterFlow.length != 0">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recent Flow rate
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>
                    <div v-if="value4[0] == null">{{ value4[0] }}<span style="font-size:15px;color:black;">L/min</span></div>
                    <div v-else>{{ value4[0].toFixed(2) }}<span style="font-size:15px;color:black;">L/min</span></div>
                  </div>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" v-else>
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recent Flow rate
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>
                    <div v-if="value4[0] == null">{{ value4[0] }}<span style="font-size:15px;color:black;">L/min</span></div>
                    <div v-else>{{ value4[0].toFixed(2) }}<span style="font-size:15px;color:black;">L/min</span></div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col>
              <v-card class="mx-auto text-center" color="red" dark max-width="200" max-height="100" v-if="value4.reduce((a, b) => a + b, 0) >= 10000 && waterFlow.length != 0">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Total Volume
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>{{ value4.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" v-else>
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Total Volume
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>{{ value4.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="location5[0] != ''">
        <v-col>
          <v-row dense>
            <v-col>
              <v-card class="mx-auto text-center" color="grey" dark max-width="200" max-height="100" @click="waterFlow5">
                <v-card-text>
                  <span style="font-size:11px;color:black;" v-if="waterFlow.length == 0">No Data</span>
                  <span style="font-size:11px;color:black;" v-else>{{ console5[0] }}</span>
                  <div style="font-size:15px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>
                    {{ location5[0] }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="mx-auto text-center" color="green" dark max-width="200" max-height="100" v-if="value5[0] != 0 && waterFlow.length != 0">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recent Flow rate
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>
                    <div v-if="value5[0] == null">{{ value5[0] }}<span style="font-size:15px;color:black;">L/min</span></div>
                    <div v-else>{{ value5[0].toFixed(2) }}<span style="font-size:15px;color:black;">L/min</span></div>
                  </div>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" v-else>
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recent Flow Rate
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>
                    <div v-if="value5[0] == null">{{ value5[0] }}<span style="font-size:15px;color:black;">L/min</span></div>
                    <div v-else>{{ value5[0].toFixed(2) }}<span style="font-size:15px;color:black;">L/min</span></div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col>
              <v-card class="mx-auto text-center" color="red" dark max-width="200" max-height="100" v-if="value5.reduce((a, b) => a + b, 0) >= 10000 && waterFlow.length != 0">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Total Volume
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>{{ value5.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" v-else>
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Total Volume
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>{{ value5.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="location6[0] != ''">
        <v-col>
          <v-row dense>
            <v-col>
              <v-card class="mx-auto text-center" color="grey" dark max-width="200" max-height="100" @click="waterFlow6">
                <v-card-text>
                  <span style="font-size:11px;color:black;" v-if="waterFlow.length == 0">No Data</span>
                  <span style="font-size:11px;color:black;" v-else>{{ console6[0] }}</span>
                  <div style="font-size:15px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:15px;color:black;" v-else>
                    {{ location6[0] }}
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="mx-auto text-center" color="green" dark max-width="200" max-height="100" v-if="value6[0] != 0 && waterFlow.length != 0">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recent Flow rate
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>
                    <div v-if="value6[0] == null">{{ value6[0] }}<span style="font-size:15px;color:black;">L/min</span></div>
                    <div v-else>{{ value6[0].toFixed(2) }}<span style="font-size:15px;color:black;">L/min</span></div>
                  </div>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" v-else>
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Recent Flow Rate
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>
                    <div v-if="value6[0] == null">{{ value6[0] }}<span style="font-size:15px;color:black;">L/min</span></div>
                    <div v-else>{{ value6[0].toFixed(2) }}<span style="font-size:15px;color:black;">L/min</span></div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col>
              <v-card class="mx-auto text-center" color="red" dark max-width="200" max-height="100" v-if="value6.reduce((a, b) => a + b, 0) >= 10000 && waterFlow.length != 0">
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Total Volume
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>{{ value6.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
              <v-card class="mx-auto text-center" color="white" dark max-width="200" max-height="100" v-else>
                <v-card-text>
                  <div style="font-size:12px;color:black;">
                    Total Volume
                  </div>
                  <div style="font-size:18px;color:black;" v-if="waterFlow.length == 0">
                    No Data
                  </div>
                  <div style="font-size:18px;color:black;" v-else>{{ value6.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:15px;color:black;">L</span></div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <br />
      <!-- <v-card-title>Logs</v-card-title>
      <v-row class="ma-0">
        <v-col v-if="loading == true">
          <v-skeleton-loader v-bind="attrs" type="table-thead, table-tbody"></v-skeleton-loader>
        </v-col>
        <v-col class="pa-3 d-flex flex-column" v-else>
          <v-card-text v-if="waterFlowLogs.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
          <v-simple-table height="500px" v-else>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="color:white;">
                    Date
                  </th>
                  <th class="text-left" style="color:white;">
                    Time (24-hour)
                  </th>
                  <th class="text-left" style="color:white;">
                    Serial Number
                  </th>
                  <th class="text-left" style="color:white;">
                    Console
                  </th>
                  <th class="text-left" style="color:white;">
                    Location
                  </th>
                  <th class="text-left" style="color:white;">
                    Value
                  </th>
                  <th class="text-left" style="color:white;">
                    Outlet Type
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in waterFlowLogs" :key="i">
                  <td>{{ formatDay(item.timestamp) }}</td>
                  <td>{{ formatTimeTd(item.timestamp) }}</td>
                  <td v-if="item.fields.v.waterFlowSn == null || item.fields.v.waterFlowSn == ''">N/A</td>
                  <td v-else>{{ item.fields.v.waterFlowSn }}</td>
                  <td v-if="item.fields.v.waterFlowConsole == null || item.fields.v.waterFlowSn == ''">N/A</td>
                  <td v-else>{{ item.fields.v.waterFlowConsole }}</td>
                  <td v-if="item.fields.v.locationRemarks == null || item.fields.v.waterFlowSn == ''">N/A</td>
                  <td v-else>{{ item.fields.v.locationRemarks }}</td>
                  <td v-if="item.fields.v.value == null || item.fields.v.waterFlowSn == ''">N/A</td>
                  <td v-else>{{ item.fields.v.value.toFixed(2) }}L</td>
                  <td>{{ item.fields.v.outletType.map(({ item }) => item).join(" + ") }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row> -->
    </v-container>
  </div>

  <div v-else>
    <div class="mt-5 pa-1" justify="center" align="center">
      <div class="pa-1">
        <v-select
          :items="location"
          item-value="_id"
          label="Location Name"
          v-model="locationItem"
          @change="updateLocation"
          :item-text="
            (location) => {
              return location.result[0].location;
            }
          "
          prepend-inner-icon="mdi-map-marker"
          solo
          style="font-size: 12px;"
          hide-details
        ></v-select>
      </div>

      <div class="pa-1">
        <v-card style="text-align:left; display:flex; justify-content:space-between;">
          <v-md-date-range-picker :presets="presets" opens="left" @change="updateData">
            <v-card class="pa-3" slot="input" flat>
              <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px; margin-left: 5px;">{{ formatDate($store.state.dateTime1) }} - {{ formatDate($store.state.dateTime2) }}</span>
            </v-card>
          </v-md-date-range-picker>
        </v-card>
      </div>
    </div>

    <br />

    <v-row justify="center" align="center" class="mt-4 mb-4">
      <div style="font-size:12px; color:grey">
        Last Updated: <span v-if="datetime.length == 0">No data</span
        ><span v-else>
          <span v-if="lastUpdate(datetime[0]).includes('ago') == true">{{ lastUpdate(datetime[0]) }}</span>
          <span v-else>{{ lastUpdate(datetime[0]).substring(2) }} ago</span></span
        >
      </div>
    </v-row>

    <v-row justify="center" align="center" class="pa-1">
      <div style="font-size:12px; background:#e8e7e6;" class="pa-3 mb-2 rounded-lg"><v-icon color="green">mdi-circle</v-icon> = Water Used <v-icon color="white">mdi-circle</v-icon> = Water Not Use <v-icon color="red">mdi-circle</v-icon> = Water > 10000L</div>
    </v-row>

    <v-container>
      <v-card class="mx-auto text-center pb-5 mb-5" @click="waterFlow1" v-if="location1[0] != ''" color="grey">
        <v-card-text>
          <span style="font-size:10px;color:#333;" v-if="waterFlow.length == 0">No Data</span>
          <span style="font-size:10px;color:#333;" v-else>{{ console1[0] }}</span>
          <div style="font-size:12px;color:#333;" v-if="waterFlow.length == 0">
            No Data
          </div>
          <div style="font-size:12px;color:#333;" v-else>
            {{ location1[0] }}
          </div>
        </v-card-text>

        <div style="display:flex; justify-content:center;">
          <v-card class="text-center mr-2" width="35vw" color="green" v-if="value1[0] != 0 && waterFlow.length != 0">
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Recent Flow Rate
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>
                <div v-if="value1[0] == null">{{ value1[0] }}<span style="font-size:10px;color:black;">L/min</span></div>
                <div v-else>{{ value1[0].toFixed(2) }}<span style="font-size:10px;color:black;">L/min</span></div>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="text-center mr-2" width="35vw" v-else>
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Recent Flow Rate
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>
                <div v-if="value1[0] == null">{{ value1[0] }}<span style="font-size:10px;color:black;">L/min</span></div>
                <div v-else>{{ value1[0].toFixed(2) }}<span style="font-size:10px;color:black;">L/min</span></div>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="text-center" width="35vw" color="red" v-if="value1.reduce((a, b) => a + b, 0) >= 10000 && waterFlow.length != 0">
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Total Volume
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>{{ value1.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card-text>
          </v-card>
          <v-card class="text-center" width="35vw" v-else>
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Total Volume
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>{{ value1.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card-text>
          </v-card>
        </div>
      </v-card>

      <v-card class="mx-auto text-center pb-5 mb-5" @click="waterFlow2" v-if="location2[0] != ''" color="grey">
        <v-card-text>
          <span style="font-size:10px;color:#333;" v-if="waterFlow.length == 0">No Data</span>
          <span style="font-size:10px;color:#333;" v-else>{{ console2[0] }}</span>
          <div style="font-size:12px;color:#333;" v-if="waterFlow.length == 0">
            No Data
          </div>
          <div style="font-size:12px;color:#333;" v-else>
            {{ location2[0] }}
          </div>
        </v-card-text>

        <div style="display:flex; justify-content:center;">
          <v-card class="text-center mr-2" width="35vw" color="green" v-if="value2[0] != 0 && waterFlow.length != 0">
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Recent Flow Rate
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>
                <div v-if="value2[0] == null">{{ value2[0] }}<span style="font-size:10px;color:black;">L/min</span></div>
                <div v-else>{{ value2[0].toFixed(2) }}<span style="font-size:10px;color:black;">L/min</span></div>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="text-center mr-2" width="35vw" v-else>
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Recent Flow Rate
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>
                <div v-if="value2[0] == null">{{ value2[0] }}<span style="font-size:10px;color:black;">L/min</span></div>
                <div v-else>{{ value2[0].toFixed(2) }}<span style="font-size:10px;color:black;">L/min</span></div>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="text-center" width="35vw" color="red" v-if="value2.reduce((a, b) => a + b, 0) >= 10000 && waterFlow.length != 0">
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Total Volume
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>{{ value2.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card-text>
          </v-card>
          <v-card class="text-center" width="35vw" v-else>
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Total Volume
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>{{ value2.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card-text>
          </v-card>
        </div>
      </v-card>

      <v-card class="mx-auto text-center pb-5 mb-5" @click="waterFlow3" v-if="location3[0] != ''" color="grey">
        <v-card-text>
          <span style="font-size:10px;color:#333;" v-if="waterFlow.length == 0">No Data</span>
          <span style="font-size:10px;color:#333;" v-else>{{ console3[0] }}</span>
          <div style="font-size:12px;color:#333;" v-if="waterFlow.length == 0">
            No Data
          </div>
          <div style="font-size:12px;color:#333;" v-else>
            {{ location3[0] }}
          </div>
        </v-card-text>

        <div style="display:flex; justify-content:center;">
          <v-card class="text-center mr-2" width="35vw" color="green" v-if="value3[0] != 0 && waterFlow.length != 0">
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Recent Flow Rate
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>
                <div v-if="value3[0] == null">{{ value3[0] }}<span style="font-size:10px;color:black;">L/min</span></div>
                <div v-else>{{ value3[0].toFixed(2) }}<span style="font-size:10px;color:black;">L/min</span></div>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="text-center mr-2" width="35vw" v-else>
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Recent Flow Rate
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>
                <div v-if="value3[0] == null">{{ value3[0] }}<span style="font-size:10px;color:black;">L/min</span></div>
                <div v-else>{{ value3[0].toFixed(2) }}<span style="font-size:10px;color:black;">L/min</span></div>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="text-center" width="35vw" color="red" v-if="value3.reduce((a, b) => a + b, 0) >= 10000 && waterFlow.length != 0">
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Total Volume
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>{{ value3.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card-text>
          </v-card>
          <v-card class="text-center" width="35vw" v-else>
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Total Volume
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>{{ value3.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card-text>
          </v-card>
        </div>
      </v-card>

      <v-card class="mx-auto text-center pb-5 mb-5" @click="waterFlow4" v-if="location4[0] != ''" color="grey">
        <v-card-text>
          <span style="font-size:10px;color:#333;" v-if="waterFlow.length == 0">No Data</span>
          <span style="font-size:10px;color:#333;" v-else>{{ console4[0] }}</span>
          <div style="font-size:12px;color:#333;" v-if="waterFlow.length == 0">
            No Data
          </div>
          <div style="font-size:12px;color:#333;" v-else>
            {{ location4[0] }}
          </div>
        </v-card-text>

        <div style="display:flex; justify-content:center;">
          <v-card class="text-center mr-2" width="35vw" color="green" v-if="value4[0] != 0 && waterFlow.length != 0">
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Recent Flow Rate
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>
                <div v-if="value4[0] == null">{{ value4[0] }}<span style="font-size:10px;color:black;">L/min</span></div>
                <div v-else>{{ value4[0].toFixed(2) }}<span style="font-size:10px;color:black;">L/min</span></div>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="text-center mr-2" width="35vw" v-else>
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Recent Flow Rate
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>
                <div v-if="value4[0] == null">{{ value4[0] }}<span style="font-size:10px;color:black;">L/min</span></div>
                <div v-else>{{ value4[0].toFixed(2) }}<span style="font-size:10px;color:black;">L/min</span></div>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="text-center" width="35vw" color="red" v-if="value4.reduce((a, b) => a + b, 0) >= 10000 && waterFlow.length != 0">
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Total Volume
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>{{ value4.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card-text>
          </v-card>
          <v-card class="text-center" width="35vw" v-else>
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Total Volume
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>{{ value4.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card-text>
          </v-card>
        </div>
      </v-card>

      <v-card class="mx-auto text-center pb-5 mb-5" @click="waterFlow5" v-if="location5[0] != ''" color="grey">
        <v-card-text>
          <span style="font-size:10px;color:#333;" v-if="waterFlow.length == 0">No Data</span>
          <span style="font-size:10px;color:#333;" v-else>{{ console5[0] }}</span>
          <div style="font-size:12px;color:#333;" v-if="waterFlow.length == 0">
            No Data
          </div>
          <div style="font-size:12px;color:#333;" v-else>
            {{ location5[0] }}
          </div>
        </v-card-text>

        <div style="display:flex; justify-content:center;">
          <v-card class="text-center mr-2" width="35vw" color="green" v-if="value5[0] != 0 && waterFlow.length != 0">
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Recent Flow Rate
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>
                <div v-if="value5[0] == null">{{ value5[0] }}<span style="font-size:10px;color:black;">L/min</span></div>
                <div v-else>{{ value5[0].toFixed(2) }}<span style="font-size:10px;color:black;">L/min</span></div>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="text-center mr-2" width="35vw" v-else>
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Recent Flow Rate
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>
                <div v-if="value5[0] == null">{{ value5[0] }}<span style="font-size:10px;color:black;">L/min</span></div>
                <div v-else>{{ value5[0].toFixed(2) }}<span style="font-size:10px;color:black;">L/min</span></div>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="text-center" width="35vw" color="red" v-if="value5.reduce((a, b) => a + b, 0) >= 10000 && waterFlow.length != 0">
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Total Volume
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>{{ value5.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card-text>
          </v-card>
          <v-card class="text-center" width="35vw" v-else>
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Total Volume
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>{{ value5.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card-text>
          </v-card>
        </div>
      </v-card>

      <v-card class="mx-auto text-center pb-5 mb-5" @click="waterFlow6" v-if="location6[0] != ''" color="grey">
        <v-card-text>
          <span style="font-size:10px;color:#333;" v-if="waterFlow.length == 0">No Data</span>
          <span style="font-size:10px;color:#333;" v-else>{{ console6[0] }}</span>
          <div style="font-size:12px;color:#333;" v-if="waterFlow.length == 0">
            No Data
          </div>
          <div style="font-size:12px;color:#333;" v-else>
            {{ location6[0] }}
          </div>
        </v-card-text>

        <div style="display:flex; justify-content:center;">
          <v-card class="text-center mr-2" width="35vw" color="green" v-if="value6[0] != 0 && waterFlow.length != 0">
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Recent Flow Rate
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>
                <div v-if="value6[0] == null">{{ value6[0] }}<span style="font-size:10px;color:black;">L/min</span></div>
                <div v-else>{{ value6[0].toFixed(2) }}<span style="font-size:10px;color:black;">L/min</span></div>
              </div>
            </v-card-text>
          </v-card>
          <v-card class="text-center mr-2" width="35vw" v-else>
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Recent Flow Rate
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>
                <div v-if="value6[0] == null">{{ value6[0] }}<span style="font-size:10px;color:black;">L/min</span></div>
                <div v-else>{{ value6[0].toFixed(2) }}<span style="font-size:10px;color:black;">L/min</span></div>
              </div>
            </v-card-text>
          </v-card>

          <v-card class="text-center" width="35vw" color="red" v-if="value6.reduce((a, b) => a + b, 0) >= 10000 && waterFlow.length != 0">
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Total Volume
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>{{ value6.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card-text>
          </v-card>
          <v-card class="text-center" width="35vw" v-else>
            <v-card-text>
              <div style="font-size:10px;color:black;">
                Total Volume
              </div>
              <div style="font-size:12px;color:black;" v-if="waterFlow.length == 0">
                No Data
              </div>
              <div style="font-size:12px;color:black;" v-else>{{ value6.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size:10px;color:black;">L</span></div>
            </v-card-text>
          </v-card>
        </div>
      </v-card>
    </v-container>

    <v-card-title>Logs</v-card-title>
    <v-row class="ma-0">
      <v-col v-if="loading">
        <v-skeleton-loader v-bind="attrs" type="table-thead, table-tbody"></v-skeleton-loader>
      </v-col>
      <v-col class="pa-3 d-flex flex-column" v-else>
        <v-card-text v-if="waterFlowLogs.length == 0" class="text-center" style="font-size: 20px">No Data</v-card-text>
        <v-simple-table height="500px" v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="color:white;">
                  Date
                </th>
                <th class="text-left" style="color:white;">
                  Time (24-hour)
                </th>
                <th class="text-left" style="color:white;">
                  Serial Number
                </th>
                <th class="text-left" style="color:white;">
                  Console
                </th>
                <th class="text-left" style="color:white;">
                  Location
                </th>
                <th class="text-left" style="color:white;">
                  Value
                </th>
                <th class="text-left" style="color:white;">
                  Outlet Type
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in waterFlowLogs" :key="i">
                <td>{{ formatDay(item.timestamp) }}</td>
                <td>{{ formatTimeTd(item.timestamp) }}</td>
                <td v-if="item.fields.v.waterFlowSn == null || item.fields.v.waterFlowSn == ''">N/A</td>
                <td v-else>{{ item.fields.v.waterFlowSn }}</td>
                <td v-if="item.fields.v.waterFlowConsole == null || item.fields.v.waterFlowSn == ''">N/A</td>
                <td v-else>{{ item.fields.v.waterFlowConsole }}</td>
                <td v-if="item.fields.v.locationRemarks == null || item.fields.v.waterFlowSn == ''">N/A</td>
                <td v-else>{{ item.fields.v.locationRemarks }}</td>
                <td v-if="item.fields.v.value == null || item.fields.v.waterFlowSn == ''">N/A</td>
                <td v-else>{{ item.fields.v.value.toFixed(2) }}L</td>
                <td>{{ item.fields.v.outletType.map(({ item }) => item).join(" + ") }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Vue from "vue";
  import axios from "axios";
  import router from "../../router";
  import moment from "moment";
  import VueApexCharts from "vue-apexcharts";

  Vue.component("apexchart", VueApexCharts);

  export default {
    data: () => ({
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Water Flow",
          disabled: true,
          href: "",
        },
        {
          text: "Usage By Location",
          disabled: true,
          href: "",
        },
      ],
      // values1: moment().subtract(24, "hour"),
      // values2: moment().endOf("day"),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment().endOf("day")],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [
            moment()
              .clone()
              .startOf("week"),
            moment()
              .clone()
              .endOf("week"),
          ],
        },
        {
          label: "Last Week",
          range: [
            moment()
              .subtract(1, "weeks")
              .startOf("week"),
            moment()
              .subtract(1, "week")
              .endOf("week"),
          ],
        },
        {
          label: "This Month",
          range: [
            moment()
              .startOf("month")
              .startOf("day"),
            moment().endOf("month"),
          ],
        },
        {
          label: "Last Month",
          range: [
            moment()
              .subtract(1, "month")
              .startOf("month"),
            moment()
              .subtract(1, "month")
              .endOf("month"),
          ],
        },
      ],
      loading: true,
      isMobile: true,
      waterFlow: [],
      waterFlowLogs: [],
      datetime: [],

      value1: [],
      value2: [],
      value3: [],
      value4: [],
      value5: [],
      value6: [],

      location1: [],
      location2: [],
      location3: [],
      location4: [],
      location5: [],
      location6: [],

      location: [],
      locationItem: [],
    }),
    mounted() {
      this.loadsWaterFlow();
      this.loadsWaterFlowLogs();
      this.loadsLocation();
      this.onResize();
      this.intervalFetchData();
      window.addEventListener("resize", this.onResize, { passive: true });
    },
    methods: {
      intervalFetchData: function() {
        setInterval(() => {
          this.loadsWaterFlow(), this.loadsWaterFlowLogs();
        }, 60000);
      },
      waterFlow1() {
        router.push("/water-flow/waterflow0/" + this.location1[0]);
      },
      waterFlow2() {
        router.push("/water-flow/waterflow1/" + this.location2[0]);
      },
      waterFlow3() {
        router.push("/water-flow/waterflow2/" + this.location3[0]);
      },
      waterFlow4() {
        router.push("/water-flow/waterflow3/" + this.location4[0]);
      },
      waterFlow5() {
        router.push("/water-flow/waterflow4/" + this.location5[0]);
      },
      waterFlow6() {
        router.push("/water-flow/waterflow5/" + this.location6[0]);
      },
      onResize() {
        this.isMobile = window.innerWidth < 700;
      },
      formatDay(value) {
        return moment(value).format("DD MMM YYYY");
      },
      formatTimeTd(value) {
        return moment(value).format("HH:mm:ss");
      },
      formatDate(value) {
        return moment(value).format("D MMM YYYY, h:mm:ss a");
      },
      lastUpdate(value) {
        return moment().from(moment(value));
      },
      loadsLocation: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/location-water-flow";
        axios
          .get(apiURL)
          .then((res) => {
            this.location = res.data;
            this.locationItem = this.location[0]._id;
            this.loadsWaterFlow();
            this.loadsWaterFlowLogs();
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsWaterFlow: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/water-flow/location/" + this.locationItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.waterFlow = res.data;

            this.datetime = res.data.map((datetime) => datetime.timestamp);
            this.console = res.data.map((value) => value.tags.waterFlowConsole);

            this.value1 = res.data.map((value) => value.fields.waterflow0.value);
            this.value2 = res.data.map((value) => value.fields.waterflow1.value);
            this.value3 = res.data.map((value) => value.fields.waterflow2.value);
            this.value4 = res.data.map((value) => value.fields.waterflow3.value);
            this.value5 = res.data.map((value) => value.fields.waterflow4.value);
            this.value6 = res.data.map((value) => value.fields.waterflow5.value);

            this.console1 = res.data.map((console) => console.fields.waterflow0.waterFlowConsole);
            this.console2 = res.data.map((console) => console.fields.waterflow1.waterFlowConsole);
            this.console3 = res.data.map((console) => console.fields.waterflow2.waterFlowConsole);
            this.console4 = res.data.map((console) => console.fields.waterflow3.waterFlowConsole);
            this.console5 = res.data.map((console) => console.fields.waterflow4.waterFlowConsole);
            this.console6 = res.data.map((console) => console.fields.waterflow5.waterFlowConsole);

            this.location1 = res.data.map((location) => location.fields.waterflow0.locationRemarks);
            this.location2 = res.data.map((location) => location.fields.waterflow1.locationRemarks);
            this.location3 = res.data.map((location) => location.fields.waterflow2.locationRemarks);
            this.location4 = res.data.map((location) => location.fields.waterflow3.locationRemarks);
            this.location5 = res.data.map((location) => location.fields.waterflow4.locationRemarks);
            this.location6 = res.data.map((location) => location.fields.waterflow5.locationRemarks);
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsWaterFlowLogs: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/water-flow/logs/" + this.locationItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.waterFlowLogs = res.data;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loading = false));
      },
      updateData(values) {
        this.values1 = values[0];
        this.values2 = values[1];
        this.$store.commit("setDateTime1", this.values1);
        this.$store.commit("setDateTime2", this.values2);
        this.loadsWaterFlow();
        this.loadsWaterFlowLogs();
        this.loading = true;
      },
      updateLocation() {
        this.loadsWaterFlow();
        this.loadsWaterFlowLogs();
        this.loading = true;
      },
    },
    beforeDestroy() {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", this.onResize, { passive: true });
      }
    },
  };
</script>

<style scoped>
  table,
  th,
  td {
    border: 2px groove;
  }
  th {
    background-color: rgb(35, 35, 35);
  }
  .pick {
    position: sticky;
    top: 52px;
    z-index: 100;
  }
</style>
